export default [
    {
        path: '/users',
        name: 'users',
        meta: {
            isSection: true
        },
        component: () => import('@/views/users/users-list/index.vue')
    },
    {
        path: '/users/add',
        name: 'users_add',
        component: () => import('@/views/users/users-details/index.vue')
    },
    {
        path: '/users/:uuid',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'users_uuid',
                component: () => import('@/views/users/users-details/index.vue'),
                props: route => ({ id: route.params.uuid })
            },
            {
                path: 'edit',
                name: 'users_uuid_edit',
                component: () => import('@/views/users/users-details/index.vue')
            },
            {
                path: 'view',
                name: 'users_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            }
        ]
    }
];
